import { Content } from '../../types';

export const kohLipeContent: Content = {
  title: 'קו ליפה – גן עדן טרופי בים אנדמן',
  imageUrl: '/images/thailand/koh-lipe/koh-lipe-wide.jpeg',
  introduction:
    'קו ליפה הינו אי קטן וקסום בים אנדמן, כ-60 ק"מ מערבית לחופי תאילנד, סמוך לגבול עם מלזיה. זהו האי הדרומי ביותר בתאילנד ולדעת רבים – גם היפה ביותר מביניהם. האי והמרחב הסובב אותו שופעים טבע מרהיב, אשר נותר שמור ומוגן בהשוואה לאיים אחרים באזור. קו ליפה מוקף במים צלולים בגווני טורקיז, עשירים בחיים ימיים מגוונים ובצמחייה תת-ימית ססגונית. חופי האי מתאפיינים בחול לבן ורך ובחלקו הצפוני ניתן למצוא גם סלעי גיר דרמטיים. כל אלו הופכים את האי ליעד אידיאלי עבור חובבי צלילה ושנורקלינג.',
  sections: [
    {
      title: 'החופים של קו ליפה',
      type: 'sub-headers',
      description: 'בקו ליפה שלושה חופים מרכזיים, כל אחד מהם בעל אופי ייחודי:',
      content: [
        {
          subtitle: 'Pattaya Beach',
          text: 'החוף המרכזי והמתוייר ביותר, המשמש כנקודת הכניסה הראשית לאי. זהו חוף רחב עם חול לבן ומים רגועים, שלאורכו פזורים מלונות, מסעדות וברים. אליו מתחבר גם ה-Walking Street, רחוב התיירות הראשי של האי, המציע חיי יום ולילה תוססים.',
        },
        {
          subtitle: 'Sunrise Beach',
          text: 'החוף הגדול ביותר מבין השלושה, הנמצא בצידו המזרחי של האי. זהו חוף פופולרי אך רגוע יותר בהשוואה ל-Pattaya Beach ומתאים במיוחד למחפשים אווירה שקטה ונופים מרהיבים של הזריחה.',
        },
        {
          subtitle: 'Sunset Beach',
          text: 'החוף הקטן והמבודד ביותר, השוכן בצידו הצפון-מערבי של האי. זהו המקום האידיאלי לצפייה בשקיעות עוצרות נשימה והינו מתאים למטיילים המחפשים רוגע ושלווה הרחק מההמולה.',
        },
      ],
    },
    {
      title: 'דרכי הגעה',
      type: 'sub-headers',
      description:
        'ההגעה לקו ליפה מורכבת מעט יותר בהשוואה לאיים אחרים בתאילנד ודורשת שילוב של טיסות, נסיעה ימית ולעיתים גם יבשתית:',
      content: [
        {
          subtitle: 'דרך טרנג או האט יאי',
          text: 'ניתן להגיע בטיסה לשדה התעופה הקרוב ביותר בטרנג (Trang) או בהאט יאי (Hat Yai), משם להמשיך בנסיעה למזח פאק ברה וממנו, במעבורת או בסירה מהירה לאי.',
        },
        {
          subtitle: 'מאיים סמוכים',
          text: 'אפשרות נוספת היא הגעה במעבורת ישירה מאיים סמוכים כגון קו לנטה, קו פי פי ופוקט בעונת התיירות (נובמבר–אפריל).',
        },
        {
          subtitle: 'ממלזיה',
          text: 'ניתן להגיע דרך האי Langkawi, ממנו יוצאות מעבורות ישירות לקו ליפה.',
        },
      ],
    },
    {
      title: 'התניידות ברחבי האי',
      type: 'sub-headers',
      description: 'האי קו ליפה קטן יחסית וניתן להסתובב בו בכמה דרכים:',
      content: [
        {
          subtitle: 'ברגל',
          text: 'בקו ליפה אין מכוניות והדרך הפשוטה ביותר להתנייד היא בהליכה רגלית. האי קטן מספיק כדי לחצות אותו בהליכה של כ-30 דקות.',
        },
        {
          subtitle: '"מוניות" מקומיות',
          text: 'אפשרות נוספת היא להשתמש באופנועים עם סירה צדדית המשמשים כמוניות מקומיות, במיוחד שימושי אם נושאים ציוד כבד או עייפים מיום של שנורקלינג.',
        },
      ],
    },
    {
      title: 'שירותי תיירות ואטרקציות',
      type: 'sub-headers',
      description: 'למרות גודלו הקטן, קו ליפה מציע מגוון רחב של שירותי תיירות:',
      content: [
        {
          subtitle: 'לינה',
          text: 'מלונות וריזורטים מכל הרמות – מאכסניות פשוטות ועד ריזורטים יוקרתיים עם נוף לים.',
        },
        {
          subtitle: 'אוכל ובילויים',
          text: 'מסעדות מגוונות, בהן מסעדות תאילנדיות מסורתיות, מסעדות מערביות, מסעדות דגים ופירות ים טריים.',
        },
        {
          subtitle: 'בילוי ופנאי',
          text: 'ברים ובתי קפה באווירה רגועה לצד מסיבות חוף.',
        },
        {
          subtitle: 'ספא וטיפולים',
          text: "מכוני מסאג' וספא המציעים טיפולים מסורתיים ומודרניים.",
        },
        {
          subtitle: 'קניות',
          text: 'חנויות מזכרות, בגדים וציוד לחוף.',
        },
        {
          subtitle: 'פעילויות ימיות',
          text: 'אטרקציות כגון טיולי שנורקלינג, צלילות מודרכות, קיאקים וסיורי איים סמוכים.',
        },
      ],
    },
    {
      title: 'למי מתאים הביקור בקו ליפה?',
      type: 'text',
      content:
        'קו ליפה הינו יעד מושלם למחפשים חופים קסומים, טבע ימי מרהיב ושקט יחסי לעומת איים מתויירים יותר בתאילנד. יחד עם זאת, בשל המרחק וההגעה המורכבת יחסית, האי פחות מתאים למטיילים עם לו"ז צפוף או למחפשים אטרקציות עירוניות ותיירותיות קלאסיות.',
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        'בשורה התחתונה, במידה והינכם מעוניינים בחוויית חוף אותנטית, מים כחולים וצלולים וחול לבן עם חיי ים מרהיבים ושילוב בין נוחות לתחושת גן עדן מבודד – קו ליפה בהחלט שווה את הדרך!',
    },
  ],
};
